import { createStore } from 'vuex'
import { i18n } from '../lang/config';

const globalStore = {
  toastrAlert: {
    alertPosition: 'top-right',
    alertduration: 15000,
  }
}

const store = createStore({
  state: {
    ...globalStore,
    roboConfig: {
      license: true,
      stationCount: 0,  // servislerden gelir
      code: 'XXX_0000_TR_00',
      stationCalfLimit: 30,
    },
    auth: {
      authority: true,
      tecnicalPersonal: true,
      role: undefined,
      mail: undefined,
      authorization: [],
      authList: []
    },
    powerLogDesc: {
        'charge': i18n.t('charge'),
        'tour': i18n.t('tour')
    },
    selected_machine: undefined,
    machine_data: undefined,
    notificationMethodList: [
      {
        type: 'T',
        desc: `Telegram`
      },
      {
        type: 'S',
        desc: `SMS`
      }
    ],
    systemDate: '', // servislerden gelir
    stationMonitoring: [], // servislerden gelir
    rfidMonitoring: [], // servislerden gelir
    liquidDiffList: [], // servislerden gelir
    controlPLC: {}, // servislerden gelir
    plcDelayList: [], // servislerden gelir
    services: [], // servislerden gelir
    allServiceData: undefined, // servislerden gelir
    errorCodeDesc: undefined, // servislerden gelir
    producer: undefined, // servislerden gelir
    systems: undefined, // servislerden gelir,
    axiosAddr: undefined
  },
  getters: {
  },
  mutations: {
    collapse() {
      try {
        if (document.querySelector("body").classList != "collapse") {
          document.querySelector("body").classList.add("collapse")
          document.getElementById("logo-big").classList.add("d-none")
          document.getElementById("logo-small").classList.remove("d-none")
        } else {
          document.querySelector("body").classList.remove("collapse")
          document.getElementById("logo-big").classList.remove("d-none")
          document.getElementById("logo-small").classList.add("d-none")
        }
      } catch (error) {
        console.error(error)
      }
    },
    fullScreen() {
      if ((document.fullScreenElement && document.fullScreenElement !== null) || (!document.mozFullScreen && !document.webkitIsFullScreen)) {
        if (document.documentElement.requestFullScreen) {
          document.documentElement.requestFullScreen();
        } else if (document.documentElement.mozRequestFullScreen) { /* Firefox */
          document.documentElement.mozRequestFullScreen();
        } else if (document.documentElement.webkitRequestFullScreen) { /* Chrome, Safari & Opera */
          document.documentElement.webkitRequestFullScreen(Element.ALLOW_KEYBOARD_INPUT);
        } else if (document.msRequestFullscreen) { /* IE/Edge */
          document.documentElement.msRequestFullscreen();
        }
        document.querySelector("#fsBtn").firstChild.classList.remove("fa-expand-arrows-alt", "zoom");
        document.querySelector("#fsBtn").firstChild.classList.add("fa-compress-arrows-alt", "fs-5", "re-zoom");
      } else {
        if (document.cancelFullScreen) {
          document.cancelFullScreen();
        } else if (document.mozCancelFullScreen) { /* Firefox */
          document.mozCancelFullScreen();
        } else if (document.webkitCancelFullScreen) { /* Chrome, Safari and Opera */
          document.webkitCancelFullScreen();
        } else if (document.msExitFullscreen) { /* IE/Edge */
          document.msExitFullscreen();
        }
        document.querySelector("#fsBtn").firstChild.classList.remove("fa-compress-arrows-alt", "fs-5", "re-zoom");
        document.querySelector("#fsBtn").firstChild.classList.add("fa-expand-arrows-alt", "zoom");
      }
    },
    navOptionsBar() {
      document.getElementById('navOptionsBar').classList.toggle("open")
    },
    async logout() {
      this.state.auth = {
        authority: false,
        role: undefined,
        mail: undefined,
        authorization: [],
        authList: []
      }
      localStorage.removeItem('token')
      localStorage.removeItem('selected_machine')
    }
  },
  actions: {
  },
  modules: {
  }
})

export default store
